import { Chip } from 'models'
import { QueryOptions } from 'interfaces/queryOptions'
import { list as baseList } from 'services/chips'
import {
  list as baseInventoryList,
  createBatch as createBillingInventoryBatch
} from 'services/billing/inventories'

export interface ChipListResponse {
  id: number
  enterprise?: string
  serial?: string
  number?: string
  service_provider?: string
  carrier?: string
  apn?: string
  apn_username?: string
  apn_password?: string
}

export interface AvailableChipResponse {
  id: number
  sku?: string
  serial?: string
  number?: string
  service_provider?: string
  carrier?: string
  apn?: string
  apn_username?: string
  apn_password?: string
}

export interface ListResponse {
  count: number
  chips: ChipListResponse[]
}

export interface AvailableListResponse {
  count: number
  chips: AvailableChipResponse[]
}

export const list = async (
  options: QueryOptions = {}
): Promise<ListResponse> => {
  const result = await baseList(options)

  const chips = result.data.map((chip) => {
    const chipAttributes = chip.attributes.attributes
    const enterpriseAttributes =
      chip.relationships?.enterprise?.attributes.attributes ?? {}

    return {
      id: chip.id,
      enterprise: enterpriseAttributes.name,
      serial: chipAttributes.serial,
      number: chipAttributes.number,
      service_provider: chipAttributes.service_provider,
      carrier: chipAttributes.carrier,
      apn: chipAttributes.apn,
      apn_username: chipAttributes.apn_username,
      apn_password: chipAttributes.apn_password
    }
  })

  return { count: result.count, chips }
}

// "Disponíveis" — itens de billing_inventories (estoque) ainda não alocados a nenhum pedido
export const listAvailable = async (
  options: QueryOptions = {}
): Promise<AvailableListResponse> => {
  const result = await baseInventoryList({
    ...options,
    filters: [
      { key: 'type', op: 'eq', value: 'simcard' },
      { key: 'status', op: 'eq', value: 'available' },
      ...(options.filters ?? [])
    ]
  })

  const chips = result.data.map((item: any) => {
    const attributes = item.attributes
    const meta = attributes.meta ?? {}

    return {
      id: item.id,
      sku: attributes.sku,
      serial: attributes.identifier,
      number: meta.number,
      service_provider: meta.service_provider,
      carrier: meta.carrier,
      apn: meta.apn,
      apn_username: meta.apn_username,
      apn_password: meta.apn_password
    }
  })

  return { count: result.count, chips }
}

interface CreateChipAttributes extends Partial<Chip> {
  imsi?: string
  currency?: string
  batch?: string
  unit_cost?: number
  supplier_id?: number
  buyer_id?: number
  country_id?: number
  tax_note_number?: string
  tax_note_series?: string
  tax_note_date?: Date
}

export const create = async (attributes: CreateChipAttributes[]) => {
  const payload = attributes.map(
    ({
      serial,
      currency,
      batch,
      unit_cost,
      supplier_id,
      buyer_id,
      country_id,
      tax_note_number,
      tax_note_series,
      tax_note_date,
      ...meta
    }) => ({
      attributes: {
        type: 'simcard',
        identifier: serial,
        currency,
        batch,
        unit_cost,
        supplier_id,
        buyer_id,
        country_id,
        tax_note_number,
        tax_note_series,
        tax_note_date,
        meta
      }
    })
  )

  await createBillingInventoryBatch(payload)
}
